<div class="object-view-section-title">
  <h4 class="object-view-section-title__title">
    {{ title() | translate }}
  </h4>

  @if (showRestrictedIndicator()) {
    <app-restricted-indicator />
  }
</div>
